module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ch04"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppvalentinemurder005#toc"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "pr"
  }, [_vm._v("PD2"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("BCC"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("11 June")]), _vm._v(" "), _c('p', {
    staticClass: "ltg"
  }, [_vm._v("Dear Rachel,")]), _vm._v(" "), _c('p', {
    staticClass: "ltg"
  }, [_vm._v("You’re very decent to go on writing so regularly. Yes. The weekend after next will be fine. I’ll be on the plane that arrives at Charles de Gaulle at 7:45 your time. It’s kind of you to offer to introduce me to some of the embassy people, but if it’s all the same to you I’d prefer not to be sociable. Could we just eat and drink a lot and catch up on the last two years? You haven’t really told me much about your job and I’ve mostly just been maundering on in my letters about the horrors of my exile. Absence has certainly made my heart grow fonder of the good old DOC—although I’d like to strangle that shit who sent me here.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("I can’t resist giving you some more of the same. You shouldn’t have given me the opening by asking about my attempts to get out of here. The simple answer is no dice. Personnel tell me stiffly that they would consider it only if I got Shipton to recommend it. Apart from the fact that he’d resist the physical effort of signing his name, he’s too satisfied with me to think of letting me go. I realize from something Horace said recently that the last PD2 was given to wheezing up the corridor and trying to pass decisions up to Shipton. Stupidly, I haven’t bothered him at all: the trickiest issue I’ve been faced with so far has been whether to let the paper recycling lab have an unscheduled batch of pencils. I said yes and Graham the DIY fanatic is still sulking.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Speaking of Graham, the other day I found in a file a memo which sums up magnificently his approach to his job. It reads thus:")])]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "ltp1"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("P/Lab: Mr E.B. White")])]), _vm._v(" "), _c('p', {
    staticClass: "ltp1"
  }, [_vm._v("With reference to your request for a paper-punch (PP14976) I must point out that you have failed to fill in on your CP/3A the box in which you are required to give your reasons for needing this item. Without this the requisition cannot be considered.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp1"
  }, [_vm._v("I should point out additionally that we have been experiencing considerable delays from the PP14976 suppliers and I think it is very unlikely that even if we approve your request there will be a delivery situation before October at the earliest.")]), _vm._v(" "), _c('p', {
    staticClass: "pr"
  }, [_vm._v("G. Illingworth APE"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("PD2.2.1")]), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Mr E.B. White is clearly a patient man. He returned a CP/3A with the crucial box filled in with the words ‘For punching holes in pieces of paper.’ Graham duly did the necessary with his rubber stamp. I contributed my mite by sending a rocket to the suppliers which had the effect of securing a delivery within the week. Graham’s pissed off about that too.")])]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "ltp"
  }, [_vm._v("News from Henry (mostly through the partition) is that he thinks that any woman who says no means yes. However, he also thinks that rapists should be castrated. He has informed his colleagues that all black men have enormous dongs. I won’t commit to paper what he thinks all black women have.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Bill has had a record crop of lettuces. He’s now bent over the summer seed catalogue.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Horace is in his element. He’s standing in for Shipton, who’s on holiday, and is trying to get approval for some mad scheme for a PD brainstorming weekend at the BCC’s Hertfordshire training centre. I am fearful that Shipton won’t have the energy to countermand the plans when gets back. Brainstorming! Sweet Jesus! How can I get out of it?")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Janice, splendid girl, finally flipped last week when Henry’s hand connected with her bum and screamed at him to fuck himself as no one else would. She has now been transferred. Her replacement is a superannuated lady who bears a strong resemblance to Eleanor Roosevelt and sports knee-length pink woollen knickers. Henry’s prospects are bleak.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Oh, I forgot. Horace is threatening to invite me home to dinner so that I can meet his wife and see the slides of their last Spanish holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("Yesterday someone put drawing pins on my chair. My cry of pain was answered from without by a raucous laugh from Tiny.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("On the plus side, I have come the heavy with Personnel over Charlie’s future prospects and the omens are propitious. He really is bright. I wouldn’t mind getting to know him better, but I can’t of course. It would finish him off with his associates.")]), _vm._v(" "), _c('p', {
    staticClass: "ltp"
  }, [_vm._v("I must stop now as I have an important meeting to prepare for. Horace and I are to state our calculator retention case before a higher court. Even the civil service never expected me to prostitute truth in such a cause—but I can’t quite see it as a resignation issue.")]), _vm._v(" "), _c('p', {
    staticClass: "pr"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("Love, "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Robert")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f7ea438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-valentinemurder010.vue
// module id = 84
// module chunks = 0